import React, { useState } from 'react';
// Import d'EmailJS
import emailjs from '@emailjs/browser';

// --- Début des Icônes SVG ---
// (Mail, Phone, MapPin, Clock, Send, Instagram)
const MailIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><rect width="20" height="16" x="2" y="4" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg>
);
const PhoneIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
);
const MapPinIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
);
const ClockIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
);
const SendIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>
);
const InstagramIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
);
// --- Fin des Icônes SVG ---
// Informations de contact
const contactInfo = [
  { icon: PhoneIcon, label: 'Téléphone', value: ['+212 699-714172', '+212 695-409571'], link: ['tel:+212699714172', 'tel:+212695409571'] },
  { icon: MailIcon, label: 'Email', value: 'contact@pestguard.ma', link: 'mailto:contact@pestguard.ma' },
  { icon: MapPinIcon, label: 'Adresse', value: 'Rabat - Maroc', link: '#' },
  { icon: ClockIcon, label: 'Disponibilité', value: 'Intervention rapide et discrète', link: null }
];

// Lien Instagram
const socialLinks = [
  { icon: InstagramIcon, href: 'https://www.instagram.com/pestguard.ma?igsh=MTA1NTRhZzJ4ZTlpMw==', label: 'Instagram' }
];

export function ContactAndFooter() {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', serviceType: '', message: '' });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [sendError, setSendError] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSending(true);
    setSendError(null);
    setFormSubmitted(false);

    const templateParams = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone || 'Non fourni',
        serviceType: formData.serviceType,
        message: formData.message,
        reply_to: formData.email
    };

    // Envoi via EmailJS avec TES informations
    emailjs.send(
      'service_8vu81u5',  // TON SERVICE ID
      'template_nh4k5ui', // TON TEMPLATE ID
      templateParams,
      'xlLi4fCpRXhI7g74V'   // TA PUBLIC KEY
    )
    .then((response) => {
       console.log('SUCCESS!', response.status, response.text);
       setFormSubmitted(true);
       setFormData({ name: '', email: '', phone: '', serviceType: '', message: '' });
       setTimeout(() => setFormSubmitted(false), 5000);
    })
    .catch((err) => {
       console.error('FAILED...', err);
       setSendError('L\'envoi du message a échoué. Veuillez réessayer ou nous contacter directement.');
    })
    .finally(() => {
        setIsSending(false);
    });
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <>
      {/* --- SECTION CONTACT --- */}
      <section id="contact" className="py-20 bg-muted/30">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* En-tête */}
          <div className="text-center mb-16">
             <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">Contactez-nous</h2>
             <p className="text-lg text-muted-foreground max-w-2xl mx-auto">Prêt à retrouver un environnement sain ? Contactez-nous pour un diagnostic gratuit.</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            {/* Colonne Informations */}
            <div className="lg:col-span-1">
              <h3 className="text-xl font-semibold mb-6 text-foreground">Nos Coordonnées</h3>
              <div className="space-y-4 mb-8">
                {contactInfo.map((info) => {
                  const IconComponent = info.icon;
                  return (
                    <div key={info.label} className="flex items-start space-x-3">
                      <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0"> <IconComponent className="w-5 h-5 text-primary" /> </div>
                      <div> <div className="text-sm font-medium text-muted-foreground">{info.label}</div> {Array.isArray(info.value) ? ( info.value.map((val, index) => ( <a key={index} href={Array.isArray(info.link) ? info.link[index] : '#'} className="block text-foreground hover:text-primary transition-colors break-words">{val}</a> )) ) : info.link ? ( <a href={info.link} className="text-foreground hover:text-primary transition-colors break-words">{info.value}</a> ) : ( <div className="text-foreground break-words">{info.value}</div> )} </div>
                    </div>
                  );
                })}
              </div>
              {/* Carte Placeholder */}
              <div className="border-0 shadow-lg overflow-hidden rounded-lg"> <a href="#" aria-label="Voir sur la carte"><div className="h-48 bg-gradient-to-br from-slate-blue/20 to-primary/20 flex items-center justify-center hover:opacity-80 transition-opacity"><div className="text-center"><MapPinIcon className="w-12 h-12 text-primary mx-auto mb-2" /><p className="text-muted-foreground">Rabat, Maroc</p><p className="text-sm text-muted-foreground">Cliquez pour voir la carte</p></div></div></a> </div>
            </div>
            {/* Colonne Formulaire */}
            <div className="lg:col-span-2">
              <div className="border-0 shadow-lg rounded-lg">
                <div className="p-8">
                  <h3 className="text-xl font-semibold mb-6 text-foreground">Envoyez-nous un message</h3>

                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6"><div><label htmlFor="name" className="text-sm font-medium">Nom Complet *</label><input id="name" type="text" value={formData.name} onChange={(e) => handleInputChange('name', e.target.value)} placeholder="Votre nom complet" required className="mt-1 block w-full px-3 py-2 bg-input-background border border-border rounded-md shadow-sm focus:outline-none focus:ring-ring focus:border-ring"/></div><div><label htmlFor="email" className="text-sm font-medium">Adresse Email *</label><input id="email" type="email" value={formData.email} onChange={(e) => handleInputChange('email', e.target.value)} placeholder="votre.email@example.com" required className="mt-1 block w-full px-3 py-2 bg-input-background border border-border rounded-md shadow-sm focus:outline-none focus:ring-ring focus:border-ring"/></div></div><div className="grid grid-cols-1 md:grid-cols-2 gap-6"><div><label htmlFor="phone" className="text-sm font-medium">Téléphone</label><input id="phone" type="tel" value={formData.phone} onChange={(e) => handleInputChange('phone', e.target.value)} placeholder="+212 6 XX XX XX XX" className="mt-1 block w-full px-3 py-2 bg-input-background border border-border rounded-md shadow-sm focus:outline-none focus:ring-ring focus:border-ring"/></div><div><label htmlFor="serviceType" className="text-sm font-medium">Type de Service *</label><select id="serviceType" value={formData.serviceType} onChange={(e) => handleInputChange('serviceType', e.target.value)} required className="mt-1 block w-full px-3 py-2 bg-input-background border border-border rounded-md shadow-sm focus:outline-none focus:ring-ring focus:border-ring"><option value="" disabled>Sélectionnez un service</option><option value="desinsectisation">Désinsectisation</option><option value="deratisation">Dératisation</option><option value="desinfection">Désinfection</option><option value="anti-reptiles">Traitement Anti-reptiles</option><option value="autre">Autre</option></select></div></div><div><label htmlFor="message" className="text-sm font-medium">Votre Message *</label><textarea id="message" value={formData.message} onChange={(e) => handleInputChange('message', e.target.value)} placeholder="Décrivez votre problème, le lieu (villa, restaurant...), et toute information pertinente..." rows={5} required className="mt-1 block w-full px-3 py-2 bg-input-background border border-border rounded-md shadow-sm focus:outline-none focus:ring-ring focus:border-ring"/></div>

                    <button
                      type="submit"
                      disabled={isSending}
                      className={`w-full bg-primary text-white py-3 text-lg font-semibold rounded-lg flex items-center justify-center transition-opacity ${isSending ? 'opacity-50 cursor-not-allowed' : 'hover:bg-primary/90'}`}
                    >
                      <SendIcon className="w-5 h-5 mr-2" />
                      {isSending ? 'Envoi en cours...' : 'Envoyer le Message'}
                    </button>
                  </form>

                  {formSubmitted && ( <div className="mt-6 p-4 bg-green-100 text-green-800 rounded-lg text-center font-medium"> Merci ! Votre message a été envoyé. Nous vous contacterons rapidement. </div> )}
                  {sendError && ( <div className="mt-6 p-4 bg-red-100 text-red-800 rounded-lg text-center font-medium"> {sendError} </div> )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- FOOTER (PIED DE PAGE) --- */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Info Entreprise */}
            <div className="md:col-span-2">
              <div className="flex items-center space-x-2 mb-4">
                <img src="/logo.png" alt="PestGuard Logo" className="w-10 h-10 rounded-lg bg-white p-1" />
                <span className="text-xl font-bold">PestGuard</span>
              </div>
              <p className="text-gray-300 mb-4 max-w-md">
                Entreprise experte en lutte antiparasitaire, désinfection et protection
                contre les nuisibles. Nous assurons des interventions rapides, efficaces
                et respectueuses des normes de sécurité.
              </p>
              <div className="flex space-x-4">
                {socialLinks.map((social) => { const IconComponent = social.icon; return ( <a key={social.label} href={social.href} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-700 rounded-lg flex items-center justify-center hover:bg-primary transition-colors" aria-label={social.label}><IconComponent className="w-5 h-5" /></a> ); })}
              </div>
            </div>
            {/* Liens Rapides */}
            <div>
              <h4 className="font-semibold mb-4">Liens Rapides</h4>
              <ul className="space-y-2 text-gray-300">
                <li><a href="#hero" className="hover:text-primary transition-colors">Accueil</a></li>
                <li><a href="#services" className="hover:text-primary transition-colors">Services</a></li>
                <li><a href="#engagements" className="hover:text-primary transition-colors">Engagements</a></li>
                <li><a href="#pour-qui" className="hover:text-primary transition-colors">Pour Qui ?</a></li>
                <li><a href="#methode" className="hover:text-primary transition-colors">Méthode</a></li>
                <li><a href="#contact" className="hover:text-primary transition-colors">Contact</a></li>
              </ul>
            </div>
            {/* Légal */}
            <div>
              <h4 className="font-semibold mb-4">Légal</h4>
              <ul className="space-y-2 text-gray-300">
                <li><a href="#" className="hover:text-primary transition-colors">Politique de confidentialité</a></li>
                <li><a href="#" className="hover:text-primary transition-colors">Conditions de service</a></li>
                <li><a href="#" className="hover:text-primary transition-colors">Accessibilité</a></li>
              </ul>
            </div>
          </div>
          {/* Barre du bas */}
          <div className="border-t border-gray-700 mt-8 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center text-gray-300 text-sm">
              <p>&copy; 2025 PestGuard. Tous droits réservés.</p> {/* J'ai mis 2025 car on y est presque ;) */}
              <p className="font-mono mt-2 md:mt-0">IF: 50555456 - ICE: 002919101000071</p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}